<template>
  <div class="table-wrapper d-flex flex-column flex-grow-1" v-if="initialized">
    <TableHeaderPanel :loading="loading"
                      :addNewButton="addNewButton"
                      :filterButton="filterButton"
                      :showChatIdFilter="showChatIdFilter"
                      :exportButton="exportButton"
                      @reset="resetPreferences"
                      @update-limit="updateLimit"
                      @search="searchPage"/>
    <div class="table-responsive flex-grow-1 d-flex flex-column px-3"
         style="height:0px; border-bottom:1px solid #c8ced3">
      <table class="table b-table table-hover table-sm border mh-100">
        <TableHeader :columnConfig="columnConfig"
                     :sortField="sortField"
                     :order="order"
                     @sort-update="updateSort"
                     @select-page="selectPage"
                     ref="header"/>
        <TableBody v-on="$listeners"
                   :list="list"
                   :columnConfig="columnConfig"
                   :start="start"
                   :selected="selected"
                   ref="body"
                   v-if="hasContent"/>
      </table>
    </div>
    <TableFooter class="bottom-controls"
                 :loading="loading"
                 :totalCount="totalCount"
                 :start="start"
                 :limit="limit"
                 :selected="selected"
                 @change-pagination="changePagination"/>
  </div>
</template>

<script>
import {API_SERVER, BASE_URL} from './../../constants/constants'
import TableHeaderPanel from './TableHeaderPanel.vue'
import TableHeader from './TableHeader.vue'
import TableBody from './TableBody.vue'
import TableFooter from './TableFooter.vue'
import DatePicker from '@/components/ui/DatePicker'

export default {
  name: 'ListingComponent',
  components: {
    TableHeaderPanel,
    TableHeader,
    TableBody,
    TableFooter,
    DatePicker
  },
  props: {
    showExportButton: true,
    showFilterButton: true,
    showChatIdFilter: false,
    requestProvider: {
      type: Function,
      required: true
    },
    columnConfig: {
      type: Array,
      default: () => [],
      required: true
    },
    addNewButton: {
      type: Function
    }
  },
  data () {
    return {
      loading: false,
      initialized: false,
      list: [],
      totalCount: 0,
      searchKey: '',
      chatId: null,
      start: 0,
      limit: 20,
      sortField: '',
      order: 0,
      selected: [],
      showModal: false,
      startDate: null,
      endDate: null
    }
  },
  computed: {
    hasContent () {
      return this.totalCount
    }
  },
  created () {
    this.onInitialize()
  },
  methods: {
    onInitialize () {
      this.$nextTick(() => {
        this.initialized = true
      })
      this.doRequest()
    },
    resetPreferences () {
      this.start = 0
      this.searchKey = ''
      this.chatId = null
      this.startDate = null
      this.endDate = null
      this.onInitialize()
    },
    doRequest () {
      this.loading = true

      this.$loading.show()
      this.requestProvider(this.getRequestParams())
        .then(({data}) => {
          if (data && data.data) {
            this.loading = false

            this.list = data.data.list
            this.totalCount = data.data.count || 0
          }
          this.$loading.hide()
        }).catch(() => {
          this.loading = false
          this.$loading.hide()
        })
    },
    getSortOrder () {
      if (this.order === 0) {
        return 'asc'
      }
      return 'desc'
    },
    getRequestParams () {
      const params = {
        start: this.start,
        limit: this.limit,
        searchKey: this.searchKey,
        chatId: this.chatId,
        sortField: this.sortField,
        sortOrder: this.getSortOrder()
      }
      return {params}
    },
    updateSort (sortField) {
      if (this.sortField === sortField) {
        this.order = this.order === 0 ? 1 : 0
      } else if (sortField === '') {
        this.order = 0
      }
      this.sortField = sortField
      this.doRequest()
    },
    searchPage () {
      this.start = 0

      this.doRequest()
    },
    updateLimit (limit) {
      this.limit = limit

      this.doRequest()
    },
    selectPage (state) {
      this.$refs.body.selectPage(state)
    },
    changePagination (start) {
      this.start = start

      this.doRequest()
    },
    filterButton () {
      if (this.showFilterButton) {
        return <b-button variant="secondary" class="mr-3" onClick={this.onClickFilterButton}>Filter</b-button>
      } else {
        return false
      }
    },
    exportButton () {
      if (this.showExportButton) {
        return <b-button variant="secondary" class="mr-3" onClick={this.onClickExportButton}>Export</b-button>
      } else {
        return false
      }
    },
    onClickFilterButton () {
    },
    onClickExportButton () {
      this.loading = true

      const params = this.getRequestParams().params
      if (this.startDate || this.endDate) {
        params.limit = 1000
      }
      this.axios({
        params: params,
        url: API_SERVER + BASE_URL + 'plate/plate-excel',
        method: 'GET',
        responseType: 'blob'
      }).then((res) => {
        if (res.data && res.data.type === 'application/json') {
          return
        }
        const url = window.URL.createObjectURL(new Blob([res.data]))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', 'plate_list.xlsx')
        link.click()
        window.URL.revokeObjectURL(url)
        this.loading = false
      })
    },
    closeModal () {
    },
    saveModal () {
      this.start = 0
      this.doRequest()
    },
    filterSubmit () {
      this.$nextTick(() => {
        this.showModal = false
      })
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/listing/ListingComponent.vue